import {GalleryImage} from '../../../components/gallery';
import {coverSize, imageUrl, IMAGE_SIZES} from '../../../components/utils/image-url';
import type {BookBlock, BookEntry} from './book-content';

const THUMB_WIDTH = 194;
const THUMB_HEIGHT = 150;

/** ширина варианта: вариант вписан в size×size, поэтому у вытянутой картинки сторона меньше size */
function variantWidth(size: number, width?: number, height?: number) {
	if (!width || !height) return size;
	const scale = Math.min(1, size / Math.max(width, height));
	return Math.round(width * scale);
}

/** srcset из наших вариантов 200/400/900 и оригинала: браузер сам берёт подходящий по ширине */
export function imageSrcSet(path: string, width?: number, height?: number): string {
	const variants = IMAGE_SIZES.filter((size) => Number.isFinite(size)) as number[];
	const entries = variants
		.filter((size) => !width || variantWidth(size, width, height) < width)
		.map((size) => `${imageUrl(path, size)} ${variantWidth(size, width, height)}w`);
	if (width) entries.push(`${imageUrl(path)} ${width}w`);
	return entries.join(', ');
}

export function imageId(block: BookBlock): string {
	return block.href?.path || '';
}

/** все картинки главы по порядку — из них собирается галерея */
export function collectImages(content?: BookBlock | null): BookBlock[] {
	const images: BookBlock[] = [];
	(function walk(node: BookEntry | BookEntry[] | undefined) {
		if (Array.isArray(node)) return node.forEach(walk);
		if (!node || typeof node !== 'object') return;
		if (node.type === 'image' && node.href?.path) images.push(node);
		for (const key of Object.keys(node)) walk((node as Record<string, never>)[key]);
	})(content?.entries);
	return images;
}

export function toGalleryImages(images: BookBlock[]): GalleryImage[] {
	return images
		.filter((image) => image.href?.path)
		.map((image) => ({
			id: imageId(image),
			url: imageUrl(image.href!.path!),
			preview: imageUrl(image.href!.path!, coverSize(image.width, image.height, THUMB_WIDTH, THUMB_HEIGHT)),
			description: image.title || '',
			credits: image.credit,
			width: image.width,
			height: image.height,
		}));
}
